// VirtualOfficeRegistration.jsx
import React from "react";

export default function VirtualOfficeRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Virtual Office
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Virtual Office Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in obtaining Virtual Office
            Registration for legal and regulatory use, helping you use a
            compliant address for incorporation, GST, and other statutory needs.
          </p>
          <p className="text-gray-700">
            From reviewing the virtual office arrangement to aligning
            documentation with company and tax registration requirements, the
            process is managed in a structured way so that your business can
            operate using a recognized virtual address.
          </p>
        </div>

        {/* Right: Image (different, square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1181400/pexels-photo-1181400.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Professionals working with virtual office setup"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Virtual Office Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps businesses collate and align key
              documents so that the virtual office address can be smoothly used
              for legal and regulatory registrations.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  PAN card of the business or applicant (proprietor/partners/
                  directors), as applicable.
                </li>
                <li>
                  Identity proof of the authorised person (Aadhaar, passport,
                  voter ID, or driving licence).
                </li>
                <li>
                  Basic business authorization or incorporation document
                  (certificate of incorporation, registration certificate, or
                  similar).
                </li>
                <li>
                  Virtual office agreement or authorization from the virtual
                  office provider, where applicable.
                </li>
                <li>
                  Any supporting address documents supplied by the virtual
                  office provider (NOC, rent/lease agreement, recent utility
                  bill).
                </li>
                <li>
                  Contact details and KYC information of the signatory or
                  authorised representative for registrations.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers structured support for using virtual office
              addresses in compliance-focused scenarios, ensuring that
              documentation and usage stay aligned with regulatory expectations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Regulatory-Compliant Solutions
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on using virtual office addresses correctly for
                  incorporation, GST, and other registrations while staying
                  within applicable legal norms.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in aligning agreements, authorizations, and KYC
                  documents so that records presented to authorities are
                  complete and consistent.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Service Delivery
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional, process-driven support from initial discussion
                  through to completion of registration-related use of the
                  virtual office address.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
